{
  "close": "Schließen",
  "home": {
    "title": "Willkommen im Techno-Z"
  },
  "floorplan": {
    "company": "Firma",
    "floor": "Ebene",
    "room": "Raum",
    "title": "Wo finde ich wen",
    "subtitle": "im Techno-Z?",
    "title-uko-tower": "Wo finde ich wen im UKO Tower?",
    "overview": "Raumübersicht"
  },
  "footer": {
    "link-to": "Webseite zum",
    "booking": "Buchungssystem"
  },
  "room": {
    "office": "My Office",
    "studio": "My Studio",
    "book": "Raum buchen",
    "booking": "Buchung",
    "available": {
      "title": "Zur freien",
      "subtitle": "Verfügung"
    }
  },
  "meeting-room": {
    "title": "Meeting",
    "to": " bis "
  },
  "validation": {
    "query-param-missing": "Query-Parameter {name} fehlt!"
  },
  "rvs-register": {
    "confirm": "Bestätigen",
    "feedback-text": {
      "register-mail": "An die angegebene E-Mail-Adresse wurde ein Bestätigungslink gesendet.<br><br>Bitte bestätigen Sie Ihre E-Mail-Adresse, um sich anzumelden und ein Passwort zu setzen.<br><br>Falls Sie keine E-Mail erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner.",
      "register-success": "Sie haben Ihre Registrierung erfolgreich abgeschlossen und sind jetzt als Benutzer*in im Reservierungs- und Community-Portal des Techno-Z Urstein angelegt.<br><br>Sie möchten sofort reservieren?<br>Dann klicken Sie <a class='link-text' href='https://techno-z.officernd.com' target='_blank'>hier</a>.<br><br>In Kürze erhalten Sie ein E-Mail mit allen wichtigen Informationen zum Techno-Z Urstein Office Home.",
      "user-exists": "Dieser Benutzer existiert bereits.<br><br>Bitte loggen Sie sich <a class='link-text' href='https://techno-z.officernd.com' target='_blank'>hier</a> ein.<br><br>Falls Sie Ihr Passwort vergessen haben, können Sie es auch dort zurücksetzen lassen."
    },
    "password": "Passwort",
    "password-repeat": "Passwort wiederholen",
    "register": "Registrieren",
    "register-headline": "Registrierung für Raiffeisen-Mitarbeiter*innen",
    "register-text": "Für die Nutzung der Raiffeisen Offices und Meetingräume im Techno-Z Urstein ist eine Registrierung notwendig.<br>Bitte hier einmalig registrieren.",
    "set-password": "Passwort festlegen",
    "validation": {
      "uppercase-letter": "Muss einen Großbuchstaben enthalten",
      "length": "Muss mindestens 8 Zeichen lang sein",
      "lowercase-letter": "Muss einen Kleinbuchstaben enthalten",
      "mail": "E-Mail muss mit rvs.at enden",
      "one-digit": "Muss mindestens eine Zahl enthalten",
      "one-symbol": "Muss mindestens ein Sonderzeichen enthalten",
      "same-password": "Passwörter müssen übereinstimmen"
    },
    "your-team": "Ihr Techno-Z Team"
  },
  "print": {
    "title": "Druckansicht",
    "requires-input": "Erfordert Eingabe",
    "description": "Beschreibung",
    "room-number": "Raumnummer",
    "preview": "Vorschau"
  }
}